const subServiceContent = {
	// iprSolutionsStartups: {
	//   title: "IPR Solutions for Startups",
	//   description:
	// 	"At Lifeintelect, we provide tailored IPR Solutions for Startups to help early-stage companies build robust IP foundations, attract investors, and scale sustainably. Our strategic guidance supports you from ideation to exit, ensuring your intellectual property drives growth and competitive advantage. Ready to strengthen your startup’s IP with Lifeintelect? Let's get started!",
	//   subServices: {
	// 	ipStrategyRoadmap: {
	// 	  title: "IP Strategy & Roadmap for Startups",
	// 	  description:
	// 		"At Lifeintelect, we help startup founders create customized IP strategies that align with their business model, product development cycle, and funding goals. We begin by assessing your innovations, business objectives, and market positioning. Our experts then identify protectable IP assets, prioritize filing strategies, and set timelines that align with commercial milestones, ensuring a structured roadmap to secure and grow your IP portfolio.",
	// 	  process: [
	// 		{
	// 		  title: "Business Assessment",
	// 		  description:
	// 			"Analyzing your startup’s business model, product cycle, and funding goals."
	// 		},
	// 		{
	// 		  title: "Innovation Identification",
	// 		  description:
	// 			"Identifying protectable innovations and potential IP assets."
	// 		},
	// 		{
	// 		  title: "Filing Prioritization",
	// 		  description:
	// 			"Prioritizing IP filings based on market needs and budget constraints."
	// 		},
	// 		{
	// 		  title: "Timeline Development",
	// 		  description:
	// 			"Setting timelines for IP protection aligned with commercial milestones."
	// 		},
	// 		{
	// 		  title: "Roadmap Integration",
	// 		  description:
	// 			"Creating a strategic IP roadmap to support long-term growth and competitiveness."
	// 		}
	// 	  ],
	// 	  closing:
	// 		"Lifeintelect’s IP Strategy & Roadmap service empowers startups to build a strong IP foundation for success. Ready to create your IP roadmap with Lifeintelect? Let's get started!"
	// 	},
	// 	costEffectiveProtection: {
	// 	  title: "Cost-Effective IP Protection",
	// 	  description:
	// 		"At Lifeintelect, we offer tailored solutions to protect your startup’s intellectual property within limited budgets. We advise on strategic filing in critical markets, leveraging provisional applications, phased protection strategies, and government subsidies or startup incentives. Our approach ensures that your IP protection is robust and cost-efficient, maximizing value without compromising quality.",
	// 	  process: [
	// 		{
	// 		  title: "Budget Analysis",
	// 		  description:
	// 			"Assessing your startup’s budget to tailor cost-effective IP protection strategies."
	// 		},
	// 		{
	// 		  title: "Market Selection",
	// 		  description:
	// 			"Advising on strategic filing in critical markets to optimize protection."
	// 		},
	// 		{
	// 		  title: "Provisional Applications",
	// 		  description:
	// 			"Utilizing provisional applications to secure early protection at lower costs."
	// 		},
	// 		{
	// 		  title: "Subsidy Identification",
	// 		  description:
	// 			"Identifying government subsidies and startup incentives to reduce filing costs."
	// 		},
	// 		{
	// 		  title: "Phased Protection",
	// 		  description:
	// 			"Implementing phased protection strategies to spread costs over time."
	// 		}
	// 	  ],
	// 	  closing:
	// 		"Lifeintelect’s Cost-Effective IP Protection service ensures your startup’s IP is secured without breaking the bank. Ready to protect your IP affordably with Lifeintelect? Let's get started!"
	// 	},
	// 	ipDueDiligenceInvestors: {
	// 	  title: "IP Due Diligence for Investors",
	// 	  description:
	// 		"At Lifeintelect, we conduct thorough IP due diligence to support startups during funding rounds. We assess the strength, ownership, scope, and risks of your IP portfolio, providing detailed reports that highlight the value of your intangible assets. Our services help build investor confidence, streamline negotiations, and ensure your IP is a compelling asset for seed, Series A, or later-stage investments.",
	// 	  process: [
	// 		{
	// 		  title: "Portfolio Assessment",
	// 		  description:
	// 			"Evaluating the strength, scope, and ownership of your IP assets."
	// 		},
	// 		{
	// 		  title: "Risk Analysis",
	// 		  description:
	// 			"Identifying risks such as infringement, ownership disputes, or gaps in protection."
	// 		},
	// 		{
	// 		  title: "Value Articulation",
	// 		  description:
	// 			"Highlighting the commercial and strategic value of your IP portfolio."
	// 		},
	// 		{
	// 		  title: "Report Compilation",
	// 		  description:
	// 			"Preparing detailed due diligence reports to support investor negotiations."
	// 		}
	// 	  ],
	// 	  closing:
	// 		"Lifeintelect’s IP Due Diligence service boosts investor confidence in your startup’s IP assets. Ready to prepare for funding with Lifeintelect? Let's get started!"
	// 	},
	// 	ipLicensingCommercialization: {
	// 	  title: "IP Licensing & Commercialization",
	// 	  description:
	// 		"At Lifeintelect, we help startups monetize their innovations through licensing and commercialization. We identify potential licensees, structure mutually beneficial agreements, and advise on technology transfer or co-development strategies. Our support ensures your IP generates revenue and fosters strategic partnerships, turning your innovations into active business assets.",
	// 	  process: [
	// 		{
	// 		  title: "Opportunity Identification",
	// 		  description:
	// 			"Identifying potential licensees or partners for your IP assets."
	// 		},
	// 		{
	// 		  title: "Agreement Structuring",
	// 		  description:
	// 			"Crafting licensing or co-development agreements to maximize value."
	// 		},
	// 		{
	// 		  title: "Negotiation Support",
	// 		  description:
	// 			"Advising on negotiations to secure favorable terms and protect your IP."
	// 		},
	// 		{
	// 		  title: "Commercialization Strategy",
	// 		  description:
	// 			"Developing strategies to bring your IP to market through partnerships."
	// 		}
	// 	  ],
	// 	  closing:
	// 		"Lifeintelect’s IP Licensing & Commercialization service turns your IP into a revenue source. Ready to monetize your innovations with Lifeintelect? Let's get started!"
	// 	},
	// 	raisingAwarenessFunding: {
	// 	  title: "Raising Awareness and Funding with IP",
	// 	  description:
	// 		"At Lifeintelect, we enhance your startup’s visibility with accelerators, incubators, and funding agencies by showcasing your IP as a core business asset. We create compelling pitch materials, innovation reports, and patent highlights that demonstrate your market potential and innovation strength. Our services help you secure grants, funding, and strategic support to fuel your growth.",
	// 	  closing:
	// 		"Lifeintelect’s Raising Awareness and Funding service amplifies your startup’s appeal to investors and funders. Ready to showcase your IP with Lifeintelect? Let's get started!"
	// 	},
	// 	startupIpPortfolio: {
	// 	  title: "Startup IP Portfolio Management",
	// 	  description:
	// 		"At Lifeintelect, we provide centralized IP portfolio management to ease the burden on startups. We track filings, renewals, jurisdictions, and documentation, ensuring nothing is missed. Our experts align your portfolio with your evolving product and market strategy, keeping it organized and strategically focused as your startup grows.",
	// 	  process: [
	// 		{
	// 		  title: "Portfolio Setup",
	// 		  description:
	// 			"Organizing your IP assets into a centralized management system."
	// 		},
	// 		{
	// 		  title: "Deadline Tracking",
	// 		  description:
	// 			"Monitoring filing and renewal deadlines across jurisdictions."
	// 		},
	// 		{
	// 		  title: "Documentation Management",
	// 		  description:
	// 			"Maintaining accurate records of all IP-related documentation."
	// 		},
	// 		{
	// 		  title: "Strategic Alignment",
	// 		  description:
	// 			"Ensuring your portfolio supports your product and market strategy."
	// 		}
	// 	  ],
	// 	  closing:
	// 		"Lifeintelect’s Startup IP Portfolio Management service keeps your IP organized and aligned with your growth. Ready to streamline your IP management with Lifeintelect? Let's get started!"
	// 	},
	// 	ipRiskManagement: {
	// 	  title: "IP Risk Management for Startups",
	// 	  description:
	// 		"At Lifeintelect, we help startups mitigate IP-related risks to avoid costly setbacks. We review agreements, conduct Freedom-to-Operate (FTO) assessments, ensure proper inventor documentation, and establish processes to protect confidential information. Our proactive approach reduces the risk of infringement, ownership disputes, or trade secret leaks, supporting your startup’s smooth growth.",
	// 	  process: [
	// 		{
	// 		  title: "Agreement Review",
	// 		  description:
	// 			"Reviewing contracts to ensure clear IP ownership and protection."
	// 		},
	// 		{
	// 		  title: "FTO Assessment",
	// 		  description:
	// 			"Conducting Freedom-to-Operate analyses to identify infringement risks."
	// 		},
	// 		{
	// 		  title: "Inventor Documentation",
	// 		  description:
	// 			"Ensuring proper documentation of inventorship to prevent disputes."
	// 		},
	// 		{
	// 		  title: "Confidentiality Processes",
	// 		  description:
	// 			"Establishing internal processes to protect trade secrets and confidential information."
	// 		}
	// 	  ],
	// 	  closing:
	// 		"Lifeintelect’s IP Risk Management service safeguards your startup from IP pitfalls. Ready to manage your IP risks with Lifeintelect? Let's get started!"
	// 	}
	//   }
	// }
	iprSolutionsStartups:{
		title: "IPR Solutions for Startups",
		description:
		  "At LifeIntelect, we understand the unique challenges faced by startups in protecting, managing, and leveraging their intellectual property. Our IPR Solutions for Startups are specifically crafted to support early-stage companies in building robust IP foundations, attracting investors, and scaling sustainably. From ideation to exit, we serve as your strategic IP partner every step of the way.",
		service_1: {
		  title: "IP Strategy & Roadmap for Startups",
		  description:
			"For startups, an effective IP strategy is key to gaining a competitive edge and long-term success. We help founders create a customized IP roadmap that aligns with their business model, product development cycle, and funding goals. This includes identifying protectable innovations, prioritizing filings, setting timelines, and ensuring alignment with commercial milestones—giving startups a structured path to secure and grow their IP assets.",
		//   process: [
		// 	{
		// 	  title: "Business Model Analysis",
		// 	  description:
		// 		"Understanding your business model, product cycle, and funding objectives.",
		// 	},
		// 	{
		// 	  title: "Innovation Identification",
		// 	  description:
		// 		"Pinpointing protectable innovations eligible for IP protection.",
		// 	},
		// 	{
		// 	  title: "Filing Prioritization",
		// 	  description:
		// 		"Prioritizing IP filings based on market goals and commercial milestones.",
		// 	},
		// 	{
		// 	  title: "Timeline Setting",
		// 	  description:
		// 		"Creating timelines for IP protection aligned with development cycles.",
		// 	},
		// 	{
		// 	  title: "Commercial Alignment",
		// 	  description:
		// 		"Ensuring IP strategy supports business growth and investor appeal.",
		// 	},
		//   ],
		//   closing:
		// 	"LifeIntelect’s IP Strategy & Roadmap service builds a strong IP foundation for your startup. Ready to align your IP with your business goals? Let's get started!",
		},
		service_2: {
		  title: "Cost-Effective IP Protection",
		  description:
			"We understand that startups operate within limited budgets. LifeIntelect offers tailored solutions to help protect your intellectual property cost-effectively. Our team advises on strategic filing in critical markets, phased protection, provisional applications, and leveraging government subsidies or startup incentives. We ensure that budget constraints don’t compromise the quality or strength of your IP protection.",
		//   process: [
		// 	{
		// 	  title: "Budget Assessment",
		// 	  description:
		// 		"Evaluating your budget to tailor cost-effective IP solutions.",
		// 	},
		// 	{
		// 	  title: "Strategic Filing",
		// 	  description:
		// 		"Advising on filing in critical markets to maximize protection.",
		// 	},
		// 	{
		// 	  title: "Phased Protection",
		// 	  description:
		// 		"Implementing provisional applications and phased filings to save costs.",
		// 	},
		// 	{
		// 	  title: "Incentive Utilization",
		// 	  description:
		// 		"Leveraging government subsidies and startup incentives for IP protection.",
		// 	},
		//   ],
		//   closing:
		// 	"LifeIntelect’s Cost-Effective IP Protection service safeguards your IP without breaking the bank. Ready to protect your startup’s IP affordably? Let's get started!",
		},
		service_3: {
		  title: "IP Due Diligence for Investors",
		  description:
			"IP is a key consideration for investors during funding rounds. We perform IP due diligence to assess the strength, ownership, scope, and risk of your IP portfolio. Our reports provide a clear understanding of your intangible assets, helping build investor confidence and facilitating smoother negotiations during seed, Series A, or later-stage investments.",
		//   subsections: [
		// 	{
		// 	  heading: "Our Due Diligence Services",
		// 	  items: [
		// 		{
		// 		  title: "Portfolio Assessment",
		// 		  description:
		// 			"Evaluating the strength and scope of your IP portfolio.",
		// 		},
		// 		{
		// 		  title: "Ownership Verification",
		// 		  description:
		// 			"Ensuring clear ownership of all IP assets.",
		// 		},
		// 		{
		// 		  title: "Risk Analysis",
		// 		  description:
		// 			"Identifying potential IP risks, such as infringement or gaps.",
		// 		},
		// 		{
		// 		  title: "Investor Reporting",
		// 		  description:
		// 			"Creating detailed reports to boost investor confidence.",
		// 		},
		// 	  ],
		// 	},
		//   ],
		//   closing:
		// 	"LifeIntelect’s IP Due Diligence service strengthens your position with investors. Ready to showcase your IP to funders? Let's get started!",
		},
		service_4: {
		  title: "IP Licensing & Commercialization",
		  description:
			"Startups often have valuable innovations that can be monetized early through licensing. We help identify potential licensees, structure win-win agreements, and advise on strategies for technology transfer and co-development. Our support ensures that your IP doesn’t just sit unused—it becomes a source of revenue and strategic partnerships.",
		//   subsections: [
		// 	{
		// 	  heading: "Our Commercialization Services",
		// 	  items: [
		// 		{
		// 		  title: "Licensee Identification",
		// 		  description:
		// 			"Finding potential licensees for your IP assets.",
		// 		},
		// 		{
		// 		  title: "Agreement Structuring",
		// 		  description:
		// 			"Crafting licensing agreements for mutual benefit.",
		// 		},
		// 		{
		// 		  title: "Technology Transfer",
		// 		  description:
		// 			"Advising on strategies for effective technology transfer.",
		// 		},
		// 		{
		// 		  title: "Co-Development Support",
		// 		  description:
		// 			"Facilitating partnerships for joint IP development.",
		// 		},
		// 	  ],
		// 	},
		//   ],
		//   closing:
		// 	"LifeIntelect’s IP Licensing & Commercialization service turns your IP into revenue. Ready to monetize your innovations? Let's get started!",
		},
		service_5: {
		  title: "Raising Awareness and Funding with IP",
		  description:
			"A well-articulated IP strategy can significantly enhance your visibility with accelerators, incubators, and funding agencies. We help you present your IP as a core business asset—creating pitch materials, innovation reports, and patent highlights that demonstrate market potential and innovation strength. Our services boost your ability to secure grants, funding, and strategic support.",
		//   process: [
		// 	{
		// 	  title: "IP Asset Highlighting",
		// 	  description:
		// 		"Identifying key IP assets to showcase in pitches.",
		// 	},
		// 	{
		// 	  title: "Pitch Material Creation",
		// 	  description:
		// 		"Developing pitch decks and reports emphasizing IP value.",
		// 	},
		// 	{
		// 	  title: "Grant Positioning",
		// 	  description:
		// 		"Positioning your IP for grants and funding opportunities.",
		// 	},
		// 	{
		// 	  title: "Strategic Support",
		// 	  description:
		// 		"Advising on engagement with accelerators and incubators.",
		// 	},
		//   ],
		//   closing:
		// 	"LifeIntelect’s Raising Awareness service amplifies your IP’s funding potential. Ready to attract investors with your IP? Let's get started!",
		},
		service_6: {
		  title: "Startup IP Portfolio Management",
		  description:
			"Managing IP filings, renewals, and strategy while running a startup can be overwhelming. We offer centralized IP portfolio management, helping startups track deadlines, renewals, jurisdictions, and documentation. This ensures nothing is missed and your portfolio remains aligned with your evolving product and market strategy.",
		//   process: [
		// 	{
		// 	  title: "Portfolio Tracking",
		// 	  description:
		// 		"Monitoring IP filings, renewals, and deadlines.",
		// 	},
		// 	{
		// 	  title: "Jurisdiction Management",
		// 	  description:
		// 		"Managing IP assets across multiple jurisdictions.",
		// 	},
		// 	{
		// 	  title: "Documentation Support",
		// 	  description:
		// 		"Organizing and maintaining IP-related documentation.",
		// 	},
		// 	{
		// 	  title: "Strategy Alignment",
		// 	  description:
		// 		"Ensuring portfolio aligns with product and market goals.",
		// 	},
		//   ],
		//   closing:
		// 	"LifeIntelect’s Startup IP Portfolio Management service keeps your IP organized. Ready to streamline your IP management? Let's get started!",
		},
		service_7: {
		  title: "IP Risk Management for Startups",
		  description:
			"Unintended infringement, ownership disputes, or unprotected trade secrets can become costly setbacks. We help startups identify and manage IP-related risks early on by reviewing agreements, conducting FTO assessments, ensuring proper inventor documentation, and setting up internal processes to protect confidential information. This reduces future legal complications and supports smoother growth.",
		//   subsections: [
		// 	{
		// 	  heading: "Our Risk Management Services",
		// 	  items: [
		// 		{
		// 		  title: "Agreement Review",
		// 		  description:
		// 			"Analyzing contracts to prevent IP disputes.",
		// 		},
		// 		{
		// 		  title: "FTO Assessments",
		// 		  description:
		// 			"Conducting freedom-to-operate assessments to avoid infringement.",
		// 		},
		// 		{
		// 		  title: "Inventor Documentation",
		// 		  description:
		// 			"Ensuring proper documentation of IP ownership.",
		// 		},
		// 		{
		// 		  title: "Confidentiality Processes",
		// 		  description:
		// 			"Setting up internal processes to protect trade secrets.",
		// 		},
		// 	  ],
		// 	},
		//   ],
		//   closing:
		// 	"LifeIntelect’s IP Risk Management service protects your startup from IP pitfalls. Ready to secure your IP risks? Let's get started!",
		},
	  }
  };
  
  export default subServiceContent;